export default "__VITE_ASSET__DuCvqSy6__"